module.exports = __webpack_public_path__ + "static/media/monet-4.55662e2c.jpeg";